"use client";

import dynamic from "next/dynamic";

import type { ApiCalculatorProps } from "./ApiCalculator";

const ApiCalculator = dynamic(() => import("./ApiCalculator").then(mod => mod.ApiCalculator), {
  ssr: false,
});

export function ApiCalculatorWrapper(props: ApiCalculatorProps) {
  return <ApiCalculator {...props} />;
}
